import tw from 'twin.macro';

import { DividerHorizontal16 } from '@/page-src/product/components/divider-horizontal-16';
import { ProductStatisticTableExp } from '@/page-src/product/components/statistic-table-exp';
import { useGetDeposits } from '@/page-src/product/pages/deposits/hooks/use-get-deposits';
import { getSavingsInterestTableText } from '@/src/@domain/savings/utils/get-interest-table-text';

export const ProductDepositInterestTableSection = () => {
  const { result, isValidProduct } = useGetDeposits();
  const { deposit } = result;

  if (!isValidProduct) return null;

  return (
    <div css={tw`bg-white-900`}>
      <DividerHorizontal16 />
      <ProductStatisticTableExp
        title="기간별 금리"
        leftTitle="기간"
        rightTitle="최고금리(기본금리)"
        selectedKey=""
        statistics={getSavingsInterestTableText(deposit.interestRateConditions)}
      />
    </div>
  );
};
